var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ramadan-badge",class:{ 'ramadan-badge_start': _vm.position === 'start' }},[_c('img',{attrs:{"src":require("./assets/ticket-simple.svg"),"alt":"ticket icon"}}),_c('span',{staticClass:"ramadan-badge__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }